export const SET_CURRENT_USER       = 'SET_CURRENT_USER';
export const USER_LOGGED_OUT        = 'USER_LOGGED_OUT';
export const ADD_FLASH_MESSAGE      = 'ADD_FLASH_MESSAGE';
export const DELETE_FLASH_MESSAGE   = 'DELETE_FLASH_MESSAGE';
export const CREATE_USER            = 'CREATE_USER';
export const USER_EXISTS            = 'USER_EXISTS';
export const SET_OTP                = 'SET_OTP';
export const VERIFY_OTP             = 'VERIFY_OTP';
export const REST_OTP               = 'REST_OTP';
export const LAST_POST              = 'LAST_POST';
export const LIST_FEED              = 'LIST_FEED';
export const ACTIVE_USER_TAB        = 'ACTIVE_USER_TAB';
export const LIST_USER_FRIENDS      = 'LIST_USER_FRIENDS';
export const DETAIL_USER_FRIEND     = 'DETAIL_USER_FRIEND';
export const LIST_USER_GALLERY      = 'LIST_USER_GALLERY';
export const DETAIL_USER_PROFILE    = 'DETAIL_USER_PROFILE';
export const COUNTRY_LIST           = 'COUNTRY_LIST';
export const STATE_LIST             = 'STATE_LIST';
export const CITY_LIST              = 'CITY_LIST';
export const ID_LIST                = 'ID_LIST';
export const PROFESSION_LIST        = 'PROFESSION_LIST';
export const CATEGORY_LIST          = 'CATEGORY_LIST';
export const DROPDOWN_USER_FRIEND   = 'DROPDOWN_USER_FRIEND';
export const LIKE_FEED              = 'LIKE_FEED';
export const LIKE_FEED_LIST         = 'LIKE_FEED_LIST';
export const POST_DETAIL            = 'POST_DETAIL';
export const COMMENT_FEED_LIST      = 'COMMENT_FEED_LIST';
export const COMMENT_FEED           = 'COMMENT_FEED';
export const LIKE_COMMENT           = 'LIKE_COMMENT';
export const LIKE_COMMENT_LIST      = 'LIKE_COMMENT_LIST';
export const IMAGE_CAROUSAL         = 'IMAGE_CAROUSAL';
export const IMAGE_LIST             = 'IMAGE_LIST';
export const LIST_TIMELINE          = 'LIST_TIMELINE';
export const MEDIA_DETAILS          = 'MEDIA_DETAILS';
export const DELETE_FEED            = 'DELETE_FEED';
export const ALBUM_DETAILS          = 'ALBUM_DETAILS';
export const LAST_ALBUM             = 'LAST_ALBUM';
export const PROMOTION_TYPE         = 'PROMOTION_TYPE';
export const CALCULATE_REACH        = 'CALCULATE_REACH';
export const HOBBY_LIST             = 'HOBBY_LIST';
export const PROMOTION_PREVIEW      = 'PROMOTION_PREVIEW';
export const PROMOTION_PAYMENT_URL  = 'PROMOTION_PAYMENT_URL';
export const PROMOTION_LIST         = 'PROMOTION_LIST';
export const PROMOTION_UPDATE       = 'PROMOTION_UPDATE';
export const PROMOTION_DETAIL       = 'PROMOTION_DETAIL';
export const FRIEND_REQUEST         = 'FRIEND_REQUEST';
export const REQUEST_RESPOND        = 'REQUEST_RESPOND';
export const REQUEST_UNFRIEND       = 'REQUEST_UNFRIEND';
export const REQUEST_CANCEL         = 'REQUEST_CANCEL';
export const PROMOTION_LIMIT        = 'PROMOTION_LIMIT';
export const COUNT_NOTIFICATION     = 'COUNT_NOTIFICATION';
export const CHANGE_LANGUAGE        = 'CHANGE_LANGUAGE';
export const CHAT_USER              = 'CHAT_USER';
export const READ_CHAT              = 'READ_CHAT';
export const CREATE_CHAT            = 'CREATE_CHAT';
export const POST_FRIEND            = 'POST_FRIEND';
export const REMOVE_CHAT            = 'REMOVE_CHAT';
export const CHAT_SEARCH            = 'CHAT_SEARCH';
export const SIGNUP                 = 'SIGNUP';
export const VERIFIED_OTP           = 'VERIFIED_OTP';
export const RESEND_OTP             = 'RESEND_OTP';
export const REVIEW_MEMBERSHIP      = 'REVIEW_MEMBERSHIP';
export const NOTIFICATION_LIST      = 'NOTIFICATION_LIST';
export const FRND_NOTIFICATION_LIST = 'FRND_NOTIFICATION_LIST';
export const READ_NOTIFICATION      = 'READ_NOTIFICATION';
export const DELETE_POST            = 'DELETE_POST';
export const SEARCH_FRIEND          = 'SEARCH_FRIEND';
export const EDIT_POST              = 'EDIT_POST';
export const CHANGE_PROFILE_PIC     = 'CHANGE_PROFILE_PIC';
export const CREATE_POLL            = 'CREATE_POLL';
export const CAST_VOTE              = 'CAST_VOTE';
export const DETAIL_POLL            = 'DETAIL_POLL'; 
export const EVC_WALLET_PAYMENT     = 'EVC_WALLET_PAYMENT';
